import {User} from "../types/User";

export const checkEnabled2FA = (user: User) => {

    return new Promise((resolve, reject) => {
        if (user && !user.two_fa) {
            window.location.replace('/app/admin/profile');
            reject();
        }
        resolve(true);
    })
}
